var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcHiddenLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M8.143 12.514a1 1 0 0 1 0-1.029l6-10a1 1 0 0 1 1.714 1.03L10.168 12l5.69 9.485a1 1 0 1 1-1.714 1.03z",
  clipRule: "evenodd"
})));
export default SvgIcHiddenLeft;